<template>
    <div id="pm-print-info-dialog">
        <div id="pm-print-info-dialog-content">
            <div style="padding: 0px;">

                <div style="padding: 20px; position: relative;">
                    <br/>
                    <h2 style="font-weight: 600; margin-bottom: 15px;">Important notice</h2>
                    <!--Printing and email sending will not be supported on the DentiCalc platform from <b style="font-weight: 600;">31st October, 2022.</b-->
                    <!--br/><br/-->

                    To create fully detailed, professional treatment plans, <b style="font-weight: 600;">switch to the "big brother" of DentiCalc, called BrightPlans</b>, our cloud-based treatment plan software.
                    <br/><br/><br/>
                    <v-btn @click="$router.push('brightplans')" dark flat style="margin-bottom: 10px; width: 240px; background: #000; height: 40px; padding: 10px 20px; border-radius: 20px;">
                        <img src="https://bright-plans.com/assets/img/brightplans-logo1.png" style="width: 20px; margin-right: 10px;" />
                        More about BrightPlans
                    </v-btn>
                    <br/>
                    <v-btn @click="$emit('print')" v-if="btn === 'print'" flat style="width: 240px; background: #eee; height: 40px; padding: 10px 20px; border-radius: 20px;">
                        <mdi size="24" style="color: #444; margin-right: 10px;">mdiPrinter</mdi>
                        Continue to print
                    </v-btn>
                    <v-btn v-else @click="$emit('send')" flat style="width: 220px; background: #eee; height: 40px; padding: 10px 20px; border-radius: 20px;">
                        <mdi size="24" style="color: #444; margin-right: 10px;">mdiEmailSendOutline</mdi>
                        Continue to send
                    </v-btn>
                    <br/><br/>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
#pm-send-dialog .theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
        border: 2px solid rgba(0,0,0,.54);
    }

    #pm-send-dialog .v-input__slot label {
        margin-top: -3px;
    }
    #pm-send-dialog .v-input__slot input {
        margin-top: 16px;
        font-size: 15px;
    }

    #pm-print-info-dialog {
        position: fixed;
        z-index: 999;
        padding: 20px;
        /* display: flex; */
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,.5);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #pm-print-info-dialog-content {
        background: #fff;
        border-radius: 10px;
        box-shadow: 5px 5px 15px rgba(0,0,0,.3);
        flex-grow: 0;
        text-align: center;
        display: inline-block;
        font-size: 14px;
        width: 100%;
        max-height: 100%;
        overflow: auto;
    }
</style>
<script>
export default {
    props: [ 'btn' ],
    data(vm) {
        return ({

        });
    },
    watch: {

    },
    created() {

    },
    activated() {

    },
    computed: {

    },
    methods: {

    },
};
</script>
